import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Demo } from './demo-content.model';
import { AccessType } from '@icullen/api/shared';
import { UpgradeSubscriptionInfo } from '../subscribe/upgrade-subscription-info.model';

@Component({
  selector: 'document-demo-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './demo-content.component.html',
  styleUrls: ['./demo-content.component.scss']
})
export class DemoContentComponent implements OnInit {

  @Input() data : Demo;
  @Input() partialAuth : boolean;
  @Input() company : string;

  constructor() { }

  ngOnInit(): void {
    //console.log(this.isMobile);
  }

  hasFullAccess(){
    return this.data.accessType === AccessType.FULL_ACCESS;
  }

  getSusbscriptionInfo() : UpgradeSubscriptionInfo {
    return {
      service : this.data?.serviceName,
      uniqueNumber : this.data?.uniqueNumber,
      company : this.company
    }
  }


}
